import { createSlice } from '@reduxjs/toolkit';
import { MessageBarType } from '@fluentui/react';

interface INotificationDetails {
    message: string;
    type: MessageBarType | undefined;
    sourcePageURL: string;
    data: any;
}

// Define a type for the slice state
interface INotificationState {
    isVisible: boolean;
    notificationDetails: Array<INotificationDetails>;
}

// Define the initial state using that type
const initialState: INotificationState = {
    isVisible: false,
    notificationDetails: [],
};

export const notificationSlice = createSlice({
    name: 'notification',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        showNotification: (state, action) => {
            state.isVisible = true;
            state.notificationDetails = [
                ...state.notificationDetails,
                ...action.payload.notificationDetails,
            ];
        },
        hideNotification: (state) => {
            state.isVisible = false;
            state.notificationDetails = [];
        },
    },
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice.reducer;
